export default __webpack_public_path__ + "static/media/my.79ef6566.png";